/*
 * Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { __decorate } from "tslib";
import { assignSlotNames, property } from '@cds/core/internal';
import { CdsButtonAction } from '@cds/core/button-action';
/**
 * Control Action Button
 *
 * ```typescript
 * import '@cds/core/forms/register.js';
 * ```
 *
 * ```html
 * <cds-control-action>
 *
 * </cds-control-action>
 * ```
 *
 * @element cds-control-action
 * @slot - For projecting text content or cds-icon
 */
export class CdsControlAction extends CdsButtonAction {
    updated(props) {
        super.updated(props);
        assignSlotNames([this, this.action ?? false]);
    }
}
__decorate([
    property({ type: String, reflect: true })
], CdsControlAction.prototype, "action", void 0);
